<template>
  <div class="approvals-create-template px-6 pt-12">
    <div class="text-h1 text-textDarkest mb-4">
      Create Approval Flow
    </div>

    <p class="text-body-1 text-textDark mb-4">
      Apply an approval template to a job profile.
    </p>

    <ApprovalTemplateDropdown
      v-model="selectedTemplateUlid"
      :items="activeTemplates"
      :selected-template="selectedTemplate"
    />

    <v-btn
      block
      rounded="lg"
      color="primary"
      variant="flat"
      height="40"
      class="text-button-1"
      :disabled="!selectedTemplateUlid || hasPendingApprovalFlows"
      @click="handleContinue"
    >
      Start Approval Flow
    </v-btn>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useApprovalFlows } from '@/stores/jobProfiles/approvalFlows';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useTracking } from '@/stores/tracking/tracking';
import ApprovalTemplateDropdown from '@/components/jobProfiles/editor/approvals/ApprovalTemplateDropdown.vue';

const approvalFlowsStore = useApprovalFlows();
const {
  activeTemplates,
  selectedTemplateUlid,
  selectedTemplate,
} = storeToRefs(approvalFlowsStore);
const { beginAssignApprovers } = approvalFlowsStore;
const { hasPendingApprovalFlows } = storeToRefs(useCurrentJobProfile());

const handleContinue = () => {
  useTracking().approvalPanelClickedStartFlow();

  try {
    beginAssignApprovers();
  } catch (error) {
    useAppSnackbar().addErrorSnackbar({
      text: error.message,
    });

    throw error;
  }
};
</script>

<style scoped lang="less">
.approvals-create-template-select {
  :deep(.v-field__append-inner .v-icon) {
    color: @text-dark;
  }

  :deep(.v-field) {
    color: @text-darkest;
    min-height: 72px;
    align-items: center;
  }

  :deep(.v-field__input) {
    min-height: 72px;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  :deep(.v-select__selection--placeholder) {
    color: @text-dark;
  }
}
</style>

<style lang="less">
.approvals-create-template-select-menu.v-overlay__content > .v-list {
  box-shadow: none;
  border: 1px solid @stroke-default;
  border-radius: 8px;
  background-color: @bg-default;
}

.approvals-create-template-select-menu .v-list-item {
  padding: 12px 16px;
  min-height: unset;
}

.approvals-create-template-select-menu .v-list-item-title {
  display: none;
}
</style>
